import { isNil } from 'lodash';
import React from 'react';
import Constants from '../../../Constants';
import './FilesFilters.scss';
import {
  FILE_LIST_MODE_TYPES,
  FILE_QUARANTINE_SORT_OPTIONS,
  FILE_READ_SORT_OPTIONS,
  FILE_WRITE_SORT_OPTIONS,
} from '../../../constants/paginationConstants';
import {
  baseSelectStyles,
  getCurrentSelectedOption,
  getNewSelectionValue,
  SelectInput,
  SelectOption,
} from '../rselect/ReactSelectUtils';
import UnsortedSelect from '../rselect/UnsortedSelect';
import PageNavigation from './PageNavigation';

const SORT_OPTIONS_READ = FILE_READ_SORT_OPTIONS;
const SORT_OPTIONS_WRITE = FILE_WRITE_SORT_OPTIONS;
const SORT_OPTIONS_QUARANTINE = FILE_QUARANTINE_SORT_OPTIONS;

const STATUS_OPTIONS_READ = [
  {
    label: 'All Files',
    value: '',
  },
  {
    label: 'Completed',
    value: Constants.IngestionStatus.COMPLETE,
  },
  {
    label: 'Failed',
    value: Constants.IngestionStatus.ERROR,
  },
  {
    label: 'In Progress',
    value: Constants.IngestionStatus.IN_PROGRESS,
  },
  {
    label: 'Partially Read',
    value: Constants.IngestionStatus.PARTIAL,
  },
  {
    label: 'Not Started',
    value: Constants.IngestionStatus.NOT_STARTED,
  },
  {
    label: 'Recovered from Error',
    value: Constants.IngestionStatus.RECOVERED,
  },
];

const STATUS_OPTIONS_WRITE = [
  {
    label: 'All Files',
    value: '',
  },
  {
    label: 'Completed',
    value: Constants.IngestionStatus.COMPLETE,
  },
  {
    label: 'Failed',
    value: Constants.IngestionStatus.ERROR,
  },
  {
    label: 'In Progress',
    value: Constants.IngestionStatus.IN_PROGRESS,
  },

  {
    label: 'Partially Written',
    value: Constants.IngestionStatus.PARTIAL,
  },
];

const styles = {
  header: {
    fontSize: 10,
    fontWeight: 500,
  },
};

class FilesFilters extends React.Component {
  _handleOrderChanged = (selectedOption) => {
    //TODO: should have a better way of resetting default value
    let orderby = getNewSelectionValue(selectedOption, true, '');

    this.props.onFiltersChanged({
      orderby: orderby,
    });
  };

  _handleStatusChanged = (selectedOption) => {
    //TODO: should have a better way of resetting default value
    let status = getNewSelectionValue(selectedOption, true, '');

    this.props.onFiltersChanged({
      status: status,
    });
  };

  render() {
    let {
      meta,
      filters: { page, size, orderby, status },
      mode,
      onFiltersChanged,
    } = this.props;
    meta = meta || {};

    let sortOptions = null;
    let statusOptions = null;

    switch (mode) {
      case FILE_LIST_MODE_TYPES.MODE_WRITE:
        sortOptions = SORT_OPTIONS_WRITE;
        statusOptions = STATUS_OPTIONS_WRITE;
        break;

      case FILE_LIST_MODE_TYPES.MODE_QUARANTINE_FILES:
        sortOptions = SORT_OPTIONS_QUARANTINE;
        break;

      case FILE_LIST_MODE_TYPES.MODE_READ:
      default:
        sortOptions = SORT_OPTIONS_READ;
        statusOptions = STATUS_OPTIONS_READ;
    }

    const sortValue = getCurrentSelectedOption(sortOptions, orderby);
    //find(sortOptions, (s) => s.value === orderby);
    const statusValue = getCurrentSelectedOption(statusOptions, status);
    //find(statusOptions, (s) => s.value === status);
    const pageCount = isNil(meta.pageCount) ? ' ' : meta.pageCount !== 0 ? meta.pageCount : 1;

    return (
      <div className="scanning-progress-holder">
        <div className="scanning-progress-text-holder">
          <div className="filters-dropdown">
            <div className="filter-drop-down-holder">
              <div style={styles.header}>SORT BY</div>
              <UnsortedSelect
                options={sortOptions}
                components={{ Input: SelectInput, Option: SelectOption }}
                isClearable={false}
                isSearchable={true}
                backspaceRemovesValue={false}
                value={sortValue}
                onChange={this._handleOrderChanged}
                styles={baseSelectStyles}
              />
            </div>
            {[FILE_LIST_MODE_TYPES.MODE_READ, FILE_LIST_MODE_TYPES.MODE_WRITE].includes(mode) && (
              <div className="filter-drop-down-holder" style={{ marginBottom: 0, height: 'auto' }}>
                <div style={styles.header}>FILTER BY FILE STATUS</div>
                <UnsortedSelect
                  options={statusOptions}
                  components={{ Input: SelectInput, Option: SelectOption }}
                  isClearable={false}
                  isSearchable={true}
                  backspaceRemovesValue={false}
                  value={statusValue}
                  onChange={this._handleStatusChanged}
                  styles={baseSelectStyles}
                />
              </div>
            )}
          </div>
          {!this.props.disablePagination && (
            <PageNavigation
              page={page}
              totalPages={pageCount}
              itemsPerPage={size}
              onChange={onFiltersChanged}
            />
          )}
        </div>
      </div>
    );
  }
}

export default FilesFilters;
